(function($) {
	
	$('.footer-sitemap-toggle').on('click', function(event) {
		event.preventDefault();
		$('.footer-menu-container').toggleClass('on');
	});

})(jQuery);